import {graphql} from 'gatsby'
import React from 'react'
import styled from 'styled-components'

import type {Props as RichTextProps} from '@/components/rich-text'
import RichText from '@/components/rich-text'
import {Text} from '@/components/text'
import {BackgroundWrapper, Section} from '@/styles/grid'
import {tokens} from '@/theme'
import mq from '@/utils/media-query'

type Props = {
    title: string
    developers_label: string
    developers: string
    links_label: string
    links: RichTextProps['content']
    copy: RichTextProps['content']
}

const DESTKTOP_BP = 'md'

export const IntegrationOverview = ({
    developers_label,
    title,
    developers,
    links_label,
    links,
    copy,
}: Props) => {
    return (
        <BackgroundWrapper $color={'grey'}>
            <ContainerWrapper>
                <MobileTitle $variant="heading-large" as="h2">
                    {title}
                </MobileTitle>
                <StyledRichText>
                    <RichText content={copy} />
                </StyledRichText>
                <div>
                    <DesktopTitle $variant="heading-large" as="h2">
                        {title}
                    </DesktopTitle>
                    <dl>
                        <SidebarDt>
                            <Text $variant="label-base-medium" as="span">
                                {developers_label}
                            </Text>
                        </SidebarDt>
                        <SidebarDd>
                            <DeveloperWrapper>
                                <Text $variant="paragraph-base">{developers}</Text>
                            </DeveloperWrapper>
                        </SidebarDd>
                        <SidebarDt>
                            <Text $variant="label-base-medium" as="span">
                                {links_label}
                            </Text>
                        </SidebarDt>
                        <SidebarDd>
                            <RichText content={links} $variant="paragraph-base-primary" />
                        </SidebarDd>
                    </dl>
                </div>
            </ContainerWrapper>
        </BackgroundWrapper>
    )
}

const ContainerWrapper = styled(Section)`
    display: grid;
    gap: ${tokens.spacing32};

    ${mq.min(DESTKTOP_BP)} {
        grid-template-columns: 1fr 2fr;
        align-items: start;
        column-gap: 80px;
    }
`

const MobileTitle = styled(Text)`
    ${mq.min(DESTKTOP_BP)} {
        display: none;
    }
`
const StyledRichText = styled.div`
    ${mq.min(DESTKTOP_BP)} {
        order: 2;
    }
`

const DesktopTitle = styled(Text)`
    margin-bottom: ${tokens.spacing40};

    ${mq.max(DESTKTOP_BP)} {
        display: none;
    }
`

const DeveloperWrapper = styled.div`
    border: ${({theme}) => theme.borders.dark};
    border-radius: ${tokens.spacing4};
    padding: ${tokens.spacing4} ${tokens.spacing8};
    margin-bottom: ${tokens.spacing16};
    max-width: fit-content;
`

const SidebarDt = styled.dt`
    margin-bottom: ${tokens.spacing12};
`

const SidebarDd = styled.dd`
    &:not(:last-child) {
        margin-bottom: ${tokens.spacing32};
    }
`

export const integrationOverviewFragment = graphql`
    fragment IntegrationOverview on PrismicSlicePageDataBodyIntegrationOverview {
        __typename
        primary {
            title
            developers_label
            developers
            links_label
            links {
                richText
            }
            copy {
                richText
            }
        }
    }
`
